import { format } from 'date-fns';
const today: string = format(new Date(), 'yyyy-MM-dd');

const Constant = {
    TAX_RATE: 1.1,
    PAGE_SIZE: [
        { value: '10',  label: '10件毎表示' },
        { value: '30',  label: '30件毎表示' },
        { value: '50',  label: '50件毎表示' },
        { value: '100', label: '100件毎表示' },
        { value: '200', label: '200件毎表示' },
    ],
    REQUEST_CATEGORY: [
        { value: '0', label: 'すべて' },
        { value: '01', label: '廃止' },
        { value: '02', label: '撤去' },
    ],
    SYSTEM_CLASS: [
        { value: '0', label: 'すべて' },
        { value: '1', label: 'Mallie' },
        { value: '2', label: 'Genesis賃貸' },
        { value: '3', label: 'Salesforce' },
    ],
    UPDATE_FLAG: [
        { value: '1', label: '新規' },
        { value: '2', label: '訂正' },
        { value: '3', label: '取消' },
    ],
    ACCEPT_STATUS: [
        { value: '00', label: '新規' },
        { value: '01', label: '廃止申込み待ち' },
        { value: '02', label: '開始申込み待ち' },
        { value: '03', label: '契約中に再点申込あり' },
        { value: '04', label: '供給承諾保留中' },
        { value: '05', label: '申込処理中' },
        { value: '06', label: '処理完了' },
        // { value: '07', label: '' },
        { value: '08', label: '処理完了（計器取換未完了）' },
        { value: '09', label: '却下' },
        { value: '10', label: '確認中' },
        { value: '55', label: '処理中' },
        { value: '98', label: '送信不要' },
        { value: '99', label: 'エラー' }
    ],
    ACCEPT_STATUS_FOR_FORM: [
        { value: '00', label: '未送信' },
        { value: '03', label: '契約中に再点申込あり' },
        { value: '05', label: '申込処理中' },
        { value: '06,08', label: '処理完了' },
        { value: '09', label: '却下' },
        { value: '98', label: '送信不要' },
        { value: '99', label: 'エラー' }
    ],
    ACCEPT_STATUS_FOR_CLOSE_FORM: [
        { value: '00', label: '未送信' },
        { value: '05', label: '申込処理中' },
        { value: '06,08', label: '処理完了' },
        { value: '09', label: '却下' },
        { value: '98', label: '送信不要' },
        { value: '99', label: 'エラー' }
    ],
    RESPONSE_STATUS: [
        { value: '', label: 'すべて' },
        { value: '1', label: '済' },
        { value: '0', label: '未' }
    ],
    TOOLTIP_DESCRIPTIONS : {
        ABOLITION_DESIRED_DATE: '廃止申込実施時の廃止希望日で検索します。',
        ACCEPT_STATUS_NNTR: '元の申込情報が送信前にキャンセルされた場合に送信不要となります。',
        CLOSE_DATE: '廃止申込を実施後に広域から連携された接続供給廃止日で検索します。',
        CLOSE_REQUEST_DATE: '廃止申込を実施した日で検索します。',
        CONTACT_ID: '連携元のシステムにより以下のIDをセット\n・Mallieの場合：契約ID\n・Genesis賃貸の場合：物件ID\n・SalesForceの場合：SalesForceID\n',
        DEMOLITION_DATE: '撤去の場合に申込を行った際の解体日で検索します。',
        OPEN_DATE: '再点申込を実施後に広域から連携された接続供給開始日で検索します。',
        PREFERRED_DATE: '再点申込実施時の再点希望日で検索します。',
        REQUEST_DATE: '再点申込を実施した日で検索します。',
    },
    SEARCH_FORM_DATA : {
        DASHBOARD: {
            date: {
                start: today,
                end: today
            },
            timestamp: new Date().getTime(),
        },
        DEFAULT: {
            contactId: '',
            powerCustomerLocationNumber: '',
            relitRequestDate: { start: today, end: today },
            relitDesiredDate: { start: '', end: '' },
            supplyStartDate: { start: '', end: '' },
            acceptStatus: ['00'],
            systemClass: '0',
            responseStatus: '0',
            timestamp: new Date().getTime(),
        },
        CLOSE_DEFAULT: {
            requestCategory: '0',
            contactId: '',
            powerCustomerLocationNumber: '',
            abolitionRequestDate: { start: today, end: today },
            abolitionDesiredDate: { start: '', end: '' },
            supplyEndDate: { start: '', end: '' },
            demolitionDate: { start: '', end: '' },
            acceptStatus: ['00'],
            systemClass: '0',
            responseStatus: '0',
            timestamp: new Date().getTime(),
        },
    },
    DASHBOARD_SEARCH_CONDITIONS: {
        OPEN_INCOMPLETE: {
            systemClass: '1',
            acceptStatus: ['00', '05'],
            relitRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        OPEN_COMPLETE: {
            systemClass: '1',
            acceptStatus: ['06,08', '98'],
            relitRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        OPEN_ERROR: {
            systemClass: '1',
            acceptStatus: ['09', '99'],
            relitRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        OPEN_INCOMPLETE_RENT: {
            systemClass: '2',
            acceptStatus: ['00', '05'],
            relitRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        OPEN_COMPLETE_RENT: {
            systemClass: '2',
            acceptStatus: ['06,08', '05'],
            relitRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        OPEN_ERROR_RENT: {
            systemClass: '2',
            acceptStatus: ['09', '99'],
            relitRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        CLOSE_INCOMPLETE: {
            systemClass: '1',
            acceptStatus: ['00', '05'],
            abolitionRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        CLOSE_COMPLETE: {
            systemClass: '1',
            acceptStatus: ['06,08', '98'],
            abolitionRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        CLOSE_ERROR: {
            systemClass: '1',
            acceptStatus: ['09', '99'],
            abolitionRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        CLOSE_INCOMPLETE_RENT: {
            systemClass: '2',
            acceptStatus: ['00', '05'],
            abolitionRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        CLOSE_COMPLETE_RENT: {
            systemClass: '2',
            acceptStatus: ['06,08', '05'],
            abolitionRequestDate: { start: today, end: today },
            timestamp: 0,
        },
        CLOSE_ERROR_RENT: {
            systemClass: '2',
            acceptStatus: ['09', '99'],
            abolitionRequestDate: { start: today, end: today },
            timestamp: 0,
        },
    }
};

export default Constant;